<template>
    
    <section>
        <div class="inner row3_1 flex mobileFlexCol alignC">   
            <article class="wd100">
                <div class="aRow3 trendSection1">
                    <h1>센터 소개</h1>
                    <div class="tab-container">  
                        <div id="tabs">
                            <button class="tab-button" v-for="(tab, index) in tabs" v-bind:class="{active: currentTab === index}" v-on:click="currentTab =index" v-bind:key="tab">
                                {{ tab }}
                            </button>
                        
                            <div class="tab-content">
                                <div v-show="currentTab==0">
                                    <div class="flex mobile-wrap">
                                        <div class="">
                                            <figure>
                                                <img src="../../assets/images/cmmnBG/center-info-structure1-2.png" alt="center-info-structure">
                                            </figure>
                                        </div>
                                        <div class="center-brief alignL">
                                            <p>
                                                <span class="blue-word">경희대 고령친화산업혁신센터</span>는 <br><br>
                                                보건복지부 산하 한국보건산업진흥원으로부터<br><br>
                                                ‘고령친화제품 권역별 고령친화산업혁신센터’로 <br><br>
                                                지정되어 수도권 특화 고령친화산업혁신센터를<br><br>
                                                구축하여 운영하고 있습니다.<br>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="middle-title">
                                        목표
                                    </div>
                                    <figure>
                                        <img src="../../assets/images/cmmnBG/center-info-structure2.png" alt="center-info-structure2">
                                    </figure>
                                    <div class="middle-title">
                                        필요성
                                    </div>
                                    <figure>
                                        <img src="../../assets/images/cmmnBG/center-info-structure3.png" alt="center-info-structure3">
                                    </figure>
                                    <div class="middle-title">
                                        추진원칙
                                    </div>
                                    <figure>
                                        <img src="../../assets/images/cmmnBG/center-info-structure4.png" alt="center-info-structure4">
                                    </figure>
                                    <div class="middle-title">
                                        세부내용
                                    </div>
                                    <figure>
                                        <img src="../../assets/images/cmmnBG/center-info-structure5-1.png" alt="center-info-structure5">
                                    </figure>

                                </div>

                                <div v-show="currentTab==1">
                                    
                                    <figure>
                                        <img src="../../assets/images/cmmnBG/center-info-structure6-1.png" alt="center-info-structure6">
                                    </figure>
                                    <figure>
                                        <img src="../../assets/images/cmmnBG/center-info-structure7-1.png" alt="center-info-structure7">
                                    </figure>
                                    <div class="middle-title">
                                        시설 현황
                                    </div>
                                    <figure>
                                        <img src="../../assets/images/cmmnBG/center-info-structure8-1.png" alt="center-info-structure8">
                                    </figure>
                                </div>
                            </div>

                        </div>
                    </div>      
                </div> 
            </article>

        </div>       
    </section> 
    
</template>

<script>

export default {
    name: 'centerInfo',
    components: {
    },
    data() {
        return {
            currentTab:0,
            tabs:['비전 및 목표', '센터 현황']
        }
    },
}

</script>

<style scoped>
    section>.inner {
        width : 160rem;
    }
    .center-brief {padding-left: 11.5rem;}
    .center-brief p {
        font-size: 3rem;
        font-weight: 500;
    }
    .middle-title {
        color:#26336A;
        font-size: 4.8rem;
        font-weight: 700;
        line-height: 7.2rem;
        letter-spacing: -0.015em;
        text-align: center;
        position: relative;
        margin-top:10rem;
        margin-bottom: 4.7rem;
    }
    .middle-title::before {
        content: '';
        width: 120px;
        height: 3px;
        border-top: 4px solid #26336A;
        position: absolute;
        top: -20px;
        left: 46%;
    }
    .blue-word {
        color:#26336A;
        font-size: 4rem;
    }
    .tab-button {
        background: none;
        border: none;
        font-size : 4rem;
        font-weight: 700;
        line-height: 72px;
        letter-spacing: -1.5%;
        color:#949494;
        cursor: pointer;
        margin-bottom: 9.5rem;
    }
    .tab-button:nth-child(2) {
        margin-left: 84px;
        position: relative;
    }
    .tab-button:nth-child(2)::after {
        position: absolute;
        top:17px;
        left: -40px;
        content: '';
        width: 2px;
        height: 40px;
        border-left: 3px solid #000000;
    }
    .tab-button.active {
        color:#26336A;
        text-decoration-line: underline;
        
    }
    @media screen and (max-width: 460px) {
        img {width: 100%; height: auto;}
        .mobile-wrap {flex-wrap: wrap;}
        .center-brief {padding-left: 0; padding-top: 2rem;}
        .middle-title::before {left:34%;}
    }
</style>

